import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureStore, ViewSettingsStore } from '@app/_stores';

/**
 * Guard for date-based routes (today, past, future, and date-specific routes).
 * Redirects to Lists when only non-date features are enabled.
 *
 * Priority: Lists > Features page
 * (Notes no longer have a standalone screen — they appear in Today/Past)
 */
export const dateFeatureGuard: CanActivateFn = (route, state) => {
    const featureStore = inject(FeatureStore);
    const viewSettingsStore = inject(ViewSettingsStore);
    const router = inject(Router);

    // If date-based features are available, allow navigation
    if (!featureStore.onlyNonDateFeaturesEnabled() && !featureStore.allFeaturesDisabled()) {
        return true;
    }

    // Redirect based on available non-date features
    if (viewSettingsStore.showListFeature()) {
        router.navigate(['/lists']);
        return false;
    }

    // If all features are disabled, allow navigation to show the empty state
    // The Today screen will show the "all features disabled" block
    return true;
};
